// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import ReactSpeedometer from 'react-d3-speedometer';
// import ScanningModal from './ScanningModal';
// import * as XLSX from 'xlsx';
// import { saveAs } from 'file-saver';

// const SiteSupervisorInput = () => {
//   const [modalOpen, setModalOpen] = useState(false);
//   const [selectedFDN, setSelectedFDN] = useState(null);
//   const [scannedData, setScannedData] = useState({});
//   const [apiData, setApiData] = useState([]);
//   const [modules, setModules] = useState(0);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [searchField, setSearchField] = useState('fdnAddress');
//   const [searchedFDNAddress, setSearchedFDNAddress] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [uploadError, setUploadError] = useState(null);
//   const baseURL = process.env.REACT_APP_API_BASE_URL;

//   const projectId = localStorage.getItem('selectedProject');

//   useEffect(() => {
//     const fetchData = async () => {
//       setIsLoading(true);
//       try {
//         const response = await apiClient.get(`get_fdn_data`, {
//           params: { projectId },
//         });
//         // Normalize the data structure
//         const normalizedData = response.data.fdnData.map(item => ({
//           ...item,
//           fdnData: item.fdnData?.fdnData || item.fdnData
//         }));
//         setApiData(normalizedData || []);
//         setModules(response.data.modules || 0);
//       } catch (error) {
//         console.error('Error fetching FDN data:', error.response?.data || error.message);
//         setApiData([]);
//         setModules(0);
//       } finally {
//         setIsLoading(false);
//       }
//     };
//     fetchData();
//   }, [projectId]);

//   const searchFDNAddress = async (moduleNumber) => {
//     try {
//       const response = await apiClient.get(`search_fdn_address`, {
//         params: {
//           projectId,
//           moduleNumber,
//         },
//       });
//       const fdnAddresses = response.data.map(item => item.fdnAddress);
//       setSearchedFDNAddress(fdnAddresses.length > 0 ? fdnAddresses : null);
//     } catch (error) {
//       console.error('Error searching FDN address:', error.response?.data || error.message);
//       setSearchedFDNAddress(null);
//     }
//   };

//   const handleSearchChange = (e) => {
//     const value =e.target.value;
//     setSearchTerm(value);

//     if (searchField === 'moduleSerialNo' && value) {
//       searchFDNAddress(value);
//     } else {
//       setSearchedFDNAddress(null);
//     }
//   };

//   const getScannerCount = (item, modules) => {
//     const cols = parseInt(item?.matchedDesignInput?.defineMatrixCols) || 0;
//     const rows = parseInt(item?.matchedDesignInput?.defineMatrixRows) || 0;
//     return cols * rows * modules;
//   };

//   const toggleModal = (fdnAddress) => {
//     setModalOpen(!modalOpen);
//     setSelectedFDN(fdnAddress);
//     if (!modalOpen && fdnAddress && !scannedData[fdnAddress]) {
//       const selectedItem = apiData.find(item => item.fdnAddress === fdnAddress);
//       const scannerCount = selectedItem ? getScannerCount(selectedItem, modules) : 0;
//       setScannedData((prev) => ({
//         ...prev,
//         [fdnAddress]: Array(scannerCount).fill(null),
//       }));
//     }
//   };

//   const StatusBar = ({ percentage, statusName }) => (
//     <div className="relative w-full h-4 bg-gray-300 rounded">
//       <div 
//         className={`absolute inset-0 rounded bg-opacity-50`}
//         style={{ width: `${percentage}%` }}
//       >
//         {statusName === 'completed' && <span className="bg-green-500 w-full h-full block rounded"></span>}
//         {statusName === 'in-progress' && <span className="bg-yellow-500 h-full block rounded"></span>}
//         {statusName === 'not-started' && <span className="bg-red-500 h-full block rounded"></span>}
//       </div>
//       <div className="absolute inset-0 flex items-center justify-center text-sm text-gray-600 font-semibold">
//         {percentage}%
//       </div>
//     </div>
//   );

//   const calculateStatus = (item) => {
//     const percentage = Math.min(item.statusPercentage || 0, 100);
//     if (percentage === 100) return { percentage: 100, statusName: 'completed' };
//     if (percentage > 0) return { percentage: Math.round(percentage), statusName: 'in-progress' };
//     return { percentage: 0, statusName: 'not-started' };
//   };

//   const filteredData = apiData.filter((item) => {
//     if (!searchTerm) return true;

//     if (searchField === 'moduleSerialNo') {
//       return searchedFDNAddress && searchedFDNAddress.includes(item.fdnAddress);
//     }

//     const value = (() => {
//       switch (searchField) {
//         case 'fdnAddress':
//           return item.fdnAddress || '';
//         case 'contractorName':
//           return item?.fdnData?.fdnData?.assigned_to?.[0]?.Contractor || '';
//         case 'installationDate':
//           return item?.fdnData?.fdnData?.assigned_to?.[0]?.installationDate || '';
//         case 'scanningOperator':
//           return item?.fdnData?.fdnData?.assigned_to?.[0]?.['Scanning Operator'] || '';
//         default:
//           return '';
//       }
//     })();

//     return value.toLowerCase().includes(searchTerm.toLowerCase());
//   });

//   const downloadExcel = async () => {
//     try {
//       const response = await apiClient.post(`download_fdn_excel`, 
//         { projectId },
//         {
//           headers: { 'Content-Type': 'application/json' },
//           responseType: 'blob',
//         }
//       );
//       const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
//       saveAs(blob, 'FDNData.xlsx');
//     } catch (error) {
//       console.error('Error downloading FDN Excel:', error.response?.data || error.message);
//       alert('Failed to download Excel file. Please try again.');
//     }
//   };

//   const handleFileUpload = async (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     setUploadError(null);
//     setIsLoading(true);

//     const formData = new FormData();
//     formData.append('file', file);

//     try {
//       const response = await apiClient.post(`assign_modules_to_fdn_through_excel`, formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//       });
//       alert('Modules assigned successfully!');
//       // Refresh data after successful upload
//       const fetchResponse = await apiClient.get(`get_fdn_data`, {
//         params: { projectId },
//       });
//       const normalizedData = fetchResponse.data.fdnData.map(item => ({
//         ...item,
//         fdnData: item.fdnData?.fdnData || item.fdnData
//       }));
//       setApiData(normalizedData || []);
//       setModules(fetchResponse.data.modules || 0);
//     } catch (error) {
//       console.error('Error uploading Excel file:', error.response?.data || error.message);
//       setUploadError('Failed to upload Excel file. Please check the file and try again.');
//     } finally {
//       setIsLoading(false);
//       // Reset file input
//       event.target.value = null;
//     }
//   };

//   const sortedFilteredData = [...filteredData].sort((a, b) => 
//     a.fdnAddress.localeCompare(b.fdnAddress)
//   );

//   return (
//     <div className="mx-auto p-6 bg-gray-50 rounded-lg w-full shadow-lg">
//       <h1 className="text-center text-4xl font-bold mb-8 text-gray-700">SITE SUPERVISOR INPUTS</h1>
//       <div className="flex items-center justify-center my-[2em]">
//         <form onSubmit={(e) => e.preventDefault()} className="flex relative w-[900px] max-w-full bg-gradient-to-r to-[#424752] rounded-lg shadow-lg transition-shadow duration-300 hover:shadow-2xl">
//           <select 
//             value={searchField}
//             onChange={(e) => {
//               setSearchField(e.target.value);
//               setSearchTerm('');
//               setSearchedFDNAddress(null);
//             }}
//             className="bg-white text-gray-700 px-3 h-12 outline-none border-r-2 border-gray-300 rounded-l-lg transition-colors duration-300"
//           >
//             <option value="fdnAddress">FDN Address</option>
//             <option value="contractorName">Contractor Name</option>
//             <option value="installationDate">Installation Date</option>
//             <option value="scanningOperator">Scanning Operator</option>
//             <option value="moduleSerialNo">Module Serial No</option>
//           </select>
//           <input
//             type="text"
//             value={searchTerm}
//             onChange={handleSearchChange}
//             placeholder={`Search by ${searchField.replace(/([A-Z])/g, ' $1').trim()}...`}
//             className="w-full h-12 pl-4 pr-10 text-gray-700 placeholder-gray-500 rounded-r-lg bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-colors duration-300"
//           />
//           <button type="submit" className="absolute inset-y-0 right-0 flex items-center pr-4 text-gray-300 hover:text-gray-900">
//             <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-4.35-4.35m1.35-6.15a7 7 0 11-14 0 7 7 0 0114 0z" />
//             </svg>
//           </button>
//         </form>
//       </div>
//       <div className="w-full bg-gray-100 shadow-inner rounded-lg p-4 flex items-center justify-center mb-4 pb-0">
//         <ReactSpeedometer
//           value={
//             filteredData.length > 0
//               ? Number(
//                   (
//                     filteredData.reduce((acc, curr) => {
//                       const status = calculateStatus(curr);
//                       return acc + status.percentage;
//                     }, 0) / filteredData.length
//                   ).toFixed(2)
//                 )
//               : 0
//           }
//           minValue={0}
//           maxValue={100}
//           segments={5}
//           needleColor="steelblue"
//           startColor="red"
//           endColor="green"
//           textColor="black"
//           height={180}
//         />
//       </div>      
//       <div className="flex justify-between items-center mb-2 mt-0">
//         <div className="relative">
//           <input
//             type="file"
//             accept=".xlsx,.xls"
//             onChange={handleFileUpload}
//             className="absolute opacity-0 w-0 h-0"
//             id="file-upload"
//             disabled={isLoading}
//           />
//           <label
//             htmlFor="file-upload"
//             className={`bg-[#424752] text-white px-4 py-3 rounded hover:bg-gray-600 cursor-pointer ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
//           >
//             {isLoading ? 'Uploading...' : 'Upload Offline File'}
//           </label>
//           {uploadError && <p className="text-red-500 text-sm mt-1">{uploadError}</p>}
//         </div>
//         <button 
//           className={`bg-[#424752] text-white px-4 py-2 rounded hover:bg-gray-600 ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
//           onClick={downloadExcel}
//           disabled={isLoading}
//         >
//           File Download For Offline
//         </button>
//       </div>
//       <table className="table-auto w-full bg-white border-collapse overflow-hidden shadow-md rounded-md">
//         <thead>
//           <tr className="bg-[#424752] text-white text-[13px] rounded-md">
//             <th className="px-4 py-2">Sr.no</th>
//             <th className="px-4 py-2">FDN Address</th>
//             <th className="px-4 py-2">Table Layout</th>
//             <th className="px-4 py-2">Status</th>
//             <th className="px-4 py-2">Contractor Name</th>
//             <th className="px-4 py-2">Installation Date</th>
//             <th className="px-4 py-2">Scanning Operator</th>
//           </tr>
//         </thead>
//         <tbody>
//           {sortedFilteredData.map((item, index) => {
//             const status = calculateStatus(item);
//             const contractorName = item?.fdnData?.assigned_to?.[0]?.Contractor || 'N/A';
//             const installationDate = item?.fdnData?.assigned_to?.[0]?.installationDate || 'N/A';
//             const scanningOperator = item?.fdnData?.assigned_to?.[0]?.['Scanning Operator'] || 'N/A';

//             return (
//               <tr key={index} className="text-center hover:bg-gray-100">
//                 <td className="px-4 py-2">{index + 1}</td>
//                 <td className="px-4 py-2">{item.fdnAddress || 'N/A'}</td>
//                 <td className="px-4 py-2">
//                   <button className="text-[#424752] hover:underline" onClick={() => toggleModal(item.fdnAddress)}>+</button>
//                 </td>
//                 <td className="px-4 py-2">
//                   <StatusBar percentage={status.percentage} statusName={status.statusName} />
//                 </td>
//                 <td className="px-4 py-2">{contractorName}</td>
//                 <td className="px-4 py-2">{installationDate}</td>
//                 <td className="px-4 py-2">{scanningOperator}</td>
//               </tr>
//             );
//           })}
//           {sortedFilteredData.length === 0 && (
//             <tr>
//               <td colSpan="7" className="text-center py-4 text-gray-500">
//                 No matching results found
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>      
//       {modalOpen && (
//         <ScanningModal
//           selectedFDN={selectedFDN}
//           modalOpen={modalOpen}
//           toggleModal={toggleModal}
//           scannerCount={apiData.find(item => item.fdnAddress === selectedFDN) ? getScannerCount(apiData.find(item => item.fdnAddress === selectedFDN), modules) : 0}
//           scannedData={scannedData}
//           setScannedData={setScannedData}
//         />
//       )}
//     </div>
//   );
// };

// export default SiteSupervisorInput;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import ReactSpeedometer from 'react-d3-speedometer';
// import ScanningModal from './ScanningModal';
// import * as XLSX from 'xlsx';
// import { saveAs } from 'file-saver';

// const SiteSupervisorInput = () => {
//   const [modalOpen, setModalOpen] = useState(false);
//   const [selectedFDN, setSelectedFDN] = useState(null);
//   const [scannedData, setScannedData] = useState({});
//   const [apiData, setApiData] = useState([]);
//   const [modules, setModules] = useState(0);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [searchField, setSearchField] = useState('fdnAddress');
//   const [searchedFDNAddress, setSearchedFDNAddress] = useState(null);

//   const projectId = localStorage.getItem('selectedProject');
//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     const fetchData = async () => {
//       setIsLoading(true);
//       try {
//         const response = await axios.get('https://redoms-backend-dev.m-devsecops.com/get_fdn_data', {
//           params: { projectId },
//         });
//         // Normalize the data structure
//         const normalizedData = response.data.fdnData.map(item => ({
//           ...item,
//           fdnData: item.fdnData?.fdnData || item.fdnData
//         }));
//         setApiData(normalizedData || []);
//         setModules(response.data.modules || 0); // Store modules
//       } catch (error) {
//         console.error('Error fetching FDN data:', error.response?.data || error.message);
//         setApiData([]);
//         setModules(0);
//       } finally {
//         setIsLoading(false);
//       }
//     };
//     fetchData();
//   }, [projectId]);

//   // Function to search FDN Address using GET API with query params
//   const searchFDNAddress = async (moduleNumber) => {
//     try {
//       const response = await axios.get('https://redoms-backend-dev.m-devsecops.com/search_fdn_address', {
//         params: {
//           projectId,
//           moduleNumber,
//         },
//       });
//       console.log('Search FDN Response:', response.data);
//       // Extract all fdnAddress values from the array response
//       const fdnAddresses = response.data.map(item => item.fdnAddress);
//       setSearchedFDNAddress(fdnAddresses.length > 0 ? fdnAddresses : null);
//     } catch (error) {
//       console.error('Error searching FDN address:', error.response?.data || error.message);
//       setSearchedFDNAddress(null); // Reset if error occurs
//     }
//   };

//   // Handle search input change
//   const handleSearchChange = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);

//     if (searchField === 'moduleSerialNo' && value) {
//       searchFDNAddress(value); // Trigger API call for Module Serial No
//     } else {
//       setSearchedFDNAddress(null); // Clear FDN Address for other search types
//     }
//   };

//   const getScannerCount = (item, modules) => {
//     const cols = parseInt(item?.matchedDesignInput?.defineMatrixCols) || 0;
//     const rows = parseInt(item?.matchedDesignInput?.defineMatrixRows) || 0;
//     return cols * rows * modules;
//   };

//   const toggleModal = (fdnAddress) => {
//     setModalOpen(!modalOpen);
//     setSelectedFDN(fdnAddress);
//     if (!modalOpen && fdnAddress && !scannedData[fdnAddress]) {
//       const selectedItem = apiData.find(item => item.fdnAddress === fdnAddress);
//       const scannerCount = selectedItem ? getScannerCount(selectedItem, modules) : 0;
//       setScannedData((prev) => ({
//         ...prev,
//         [fdnAddress]: Array(scannerCount).fill(null),
//       }));
//     }
//   };

//   const StatusBar = ({ percentage, statusName }) => (
//     <div className="relative w-full h-4 bg-gray-300 rounded">
//       <div 
//         className={`absolute inset-0 rounded bg-opacity-50`}
//         style={{ width: `${percentage}%` }}
//       >
//         {statusName === 'completed' && <span className="bg-green-500 w-full h-full block rounded"></span>}
//         {statusName === 'in-progress' && <span className="bg-yellow-500 h-full block rounded"></span>}
//         {statusName === 'not-started' && <span className="bg-red-500 h-full block rounded"></span>}
//       </div>
//       <div className="absolute inset-0 flex items-center justify-center text-sm text-gray-600 font-semibold">
//         {percentage}%
//       </div>
//     </div>
//   );

//   const calculateStatus = (item) => {
//     const percentage = Math.min(item.statusPercentage || 0, 100);
//     if (percentage === 100) return { percentage: 100, statusName: 'completed' };
//     if (percentage > 0) return { percentage: Math.round(percentage), statusName: 'in-progress' };
//     return { percentage: 0, statusName: 'not-started' };
//   };

//   // Filter table data based on search term and selected field
//   const filteredData = apiData.filter((item) => {
//     if (!searchTerm) return true;

//     if (searchField === 'moduleSerialNo') {
//       // Filter by any FDN Address in the searchedFDNAddress array
//       return searchedFDNAddress && searchedFDNAddress.includes(item.fdnAddress);
//     }

//     const value = (() => {
//       switch (searchField) {
//         case 'fdnAddress':
//           return item.fdnAddress || '';
//         case 'contractorName':
//           return item?.fdnData?.fdnData?.assigned_to?.[0]?.Contractor || '';  // Added extra fdnData level
//         case 'installationDate':
//           return item?.fdnData?.fdnData?.assigned_to?.[0]?.installationDate || '';  // Added extra fdnData level
//         case 'scanningOperator':
//           return item?.fdnData?.fdnData?.assigned_to?.[0]?.['Scanning Operator'] || '';  // Added extra fdnData level
//         default:
//           return '';
//       }
//     })();

//     return value.toLowerCase().includes(searchTerm.toLowerCase());
//   });

//   const downloadExcel = () => {
//     // Prepare data for export based on filteredData
//     const exportData = filteredData.map((item, index) => ({
//       'Sr.no': index + 1,
//       'FDN Address': item.fdnAddress || 'N/A',
//       'Status': calculateStatus(item).percentage + '% (' + calculateStatus(item).statusName + ')',
//       'Contractor Name': item?.fdnData?.fdnData?.assigned_to?.[0]?.Contractor || 'N/A',  // Added extra fdnData level
//       'Installation Date': item?.fdnData?.fdnData?.assigned_to?.[0]?.installationDate || 'N/A',  // Added extra fdnData level
//       'Scanning Operator': item?.fdnData?.fdnData?.assigned_to?.[0]?.['Scanning Operator'] || 'N/A',  // Added extra fdnData level
//     }));
  
//     // Create worksheet
//     const worksheet = XLSX.utils.json_to_sheet(exportData);
    
//     // Define column widths (optional, for better readability)
//     worksheet['!cols'] = [
//       { wch: 10 }, // Sr.no
//       { wch: 40 }, // FDN Address
//       { wch: 20 }, // Status
//       { wch: 20 }, // Contractor Name
//       { wch: 20 }, // Installation Date
//       { wch: 20 }, // Scanning Operator
//     ];
  
//     // Create workbook and append worksheet
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, 'SiteSupervisorData');
  
//     // Generate Excel file and trigger download
//     const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
//     const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
//     saveAs(blob, 'SiteSupervisorData.xlsx');
//   };

//   const sortedFilteredData = [...filteredData].sort((a, b) => 
//     a.fdnAddress.localeCompare(b.fdnAddress)
//   );

//   return (
//     <div className="mx-auto p-6 bg-gray-50 rounded-lg w-full shadow-lg">
//       <h1 className="text-center text-4xl font-bold mb-8 text-gray-700">SITE SUPERVISOR INPUTS</h1>
//       <div className="flex items-center justify-center my-[2em]">
//         <form onSubmit={(e) => e.preventDefault()} className="flex relative w-[900px] max-w-full bg-gradient-to-r to-[#424752] rounded-lg shadow-lg transition-shadow duration-300 hover:shadow-2xl">
//           <select 
//             value={searchField}
//             onChange={(e) => {
//               setSearchField(e.target.value);
//               setSearchTerm(''); // Clear search term when changing field
//               setSearchedFDNAddress(null); // Reset FDN Address
//             }}
//             className="bg-white text-gray-700 px-3 h-12 outline-none border-r-2 border-gray-300 rounded-l-lg transition-colors duration-300"
//           >
//             <option value="fdnAddress">FDN Address</option>
//             <option value="contractorName">Contractor Name</option>
//             <option value="installationDate">Installation Date</option>
//             <option value="scanningOperator">Scanning Operator</option>
//             <option value="moduleSerialNo">Module Serial No</option>
//           </select>
//           <input
//             type="text"
//             value={searchTerm}
//             onChange={handleSearchChange}
//             placeholder={`Search by ${searchField.replace(/([A-Z])/g, ' $1').trim()}...`}
//             className="w-full h-12 pl-4 pr-10 text-gray-700 placeholder-gray-500 rounded-r-lg bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-colors duration-300"
//           />
//           <button type="submit" className="absolute inset-y-0 right-0 flex items-center pr-4 text-gray-300 hover:text-gray-900">
//             <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-4.35-4.35m1.35-6.15a7 7 0 11-14 0 7 7 0 0114 0z" />
//             </svg>
//           </button>
//         </form>
//       </div>
//       <div className="w-full bg-gray-100 shadow-inner rounded-lg p-4 flex items-center justify-center mb-4 pb-0">
//         <ReactSpeedometer
//           value={
//             filteredData.length > 0
//               ? Number(
//                   (
//                     filteredData.reduce((acc, curr) => {
//                       const status = calculateStatus(curr);
//                       return acc + status.percentage;
//                     }, 0) / filteredData.length
//                   ).toFixed(2)
//                 )
//               : 0
//           }
//           minValue={0}
//           maxValue={100}
//           segments={5}
//           needleColor="steelblue"
//           startColor="red"
//           endColor="green"
//           textColor="black"
//           height={180}
//         />
//       </div>      
//       <div className="flex justify-between mb-2 mt-0">
//         <button className="bg-[#424752] text-white px-4 py-2 rounded hover:bg-gray-600" onClick={() => alert('Feature coming soon')}>
//           Drone File Upload
//         </button>
//         <button 
//           className="bg-[#424752] text-white px-4 py-2 rounded hover:bg-gray-600" 
//           onClick={downloadExcel}
//         >
//           Download
//         </button>
//       </div>
//       <table className="table-auto w-full bg-white border-collapse overflow-hidden shadow-md rounded-md">
//         <thead>
//           <tr className="bg-[#424752] text-white text-[13px] rounded-md">
//             <th className="px-4 py-2">Sr.no</th>
//             <th className="px-4 py-2">FDN Address</th>
//             <th className="px-4 py-2">Table Layout</th>
//             <th className="px-4 py-2">Status</th>
//             <th className="px-4 py-2">Contractor Name</th>
//             <th className="px-4 py-2">Installation Date</th>
//             <th className="px-4 py-2">Scanning Operator</th>
//           </tr>
//         </thead>
//         <tbody>
//           {sortedFilteredData.map((item, index) => {
//             const status = calculateStatus(item);
//             const contractorName = item?.fdnData?.fdnData?.assigned_to?.[0]?.Contractor || 'N/A';  // Added extra fdnData level
//             const installationDate = item?.fdnData?.fdnData?.assigned_to?.[0]?.installationDate || 'N/A';  // Added extra fdnData level
//             const scanningOperator = item?.fdnData?.fdnData?.assigned_to?.[0]?.['Scanning Operator'] || 'N/A';  // Added extra fdnData level

//             return (
//               <tr key={index} className="text-center hover:bg-gray-100">
//                 <td className="px-4 py-2">{index + 1}</td>
//                 <td className="px-4 py-2">{item.fdnAddress || 'N/A'}</td>
//                 <td className="px-4 py-2">
//                   <button className="text-[#424752] hover:underline" onClick={() => toggleModal(item.fdnAddress)}>+</button>
//                 </td>
//                 <td className="px-4 py-2">
//                   <StatusBar percentage={status.percentage} statusName={status.statusName} />
//                 </td>
//                 <td className="px-4 py-2">{contractorName}</td>
//                 <td className="px-4 py-2">{installationDate}</td>
//                 <td className="px-4 py-2">{scanningOperator}</td>
//               </tr>
//             );
//           })}
//           {sortedFilteredData.length === 0 && (
//             <tr>
//               <td colSpan="7" className="text-center py-4 text-gray-500">
//                 No matching results found
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>      
//       {modalOpen && (
//         <ScanningModal
//           selectedFDN={selectedFDN}
//           modalOpen={modalOpen}
//           toggleModal={toggleModal}
//           scannerCount={apiData.find(item => item.fdnAddress === selectedFDN) ? getScannerCount(apiData.find(item => item.fdnAddress === selectedFDN), modules) : 0}
//           scannedData={scannedData}
//           setScannedData={setScannedData}
//       />
//     )}
//     </div>
//   );
// };

// export default SiteSupervisorInput;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ReactSpeedometer from 'react-d3-speedometer';
import ScanningModal from './ScanningModal';
import { saveAs } from 'file-saver';
import apiClient from '../../pages/keycloak/axiosInstance';

// ← ADDED: role names treated as admin (must match Keycloak exactly)
const ADMIN_ROLES = ['admin', 'Admin', 'ADMIN'];

const SiteSupervisorInput = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedFDN, setSelectedFDN] = useState(null);
  const [scannedData, setScannedData] = useState({});
  const [apiData, setApiData] = useState([]);
  const [modules, setModules] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchField, setSearchField] = useState('fdnAddress');
  const [searchedFDNAddress, setSearchedFDNAddress] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadError, setUploadError] = useState(null);

  const [canUploadOffline, setCanUploadOffline] = useState(false);
  const [allowedCompanies, setAllowedCompanies] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false); // ← ADDED

  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const projectId = localStorage.getItem('selectedProject');

  // ← UPDATED: Extract allowed companies from _Contractor or _Scanning Operator roles
  useEffect(() => {
    const storedRoles = sessionStorage.getItem("userRoles");
    if (storedRoles) {
      let roles = [];
      try {
        const parsed = JSON.parse(storedRoles);
        if (Array.isArray(parsed)) roles = parsed;
      } catch {
        roles = storedRoles.split(",").map(r => r.trim());
      }
      setCanUploadOffline(roles.includes("Site_Supervisor_Edit"));

      // ← ADDED: admin sees every FDN address, assigned or not
      const adminRoles = ADMIN_ROLES.map(r => r.toLowerCase());
      setIsAdmin(roles.some(role => adminRoles.includes(String(role).trim().toLowerCase())));

      // Extract company names from _Contractor or _Scanning Operator roles
      const companies = new Set();
      roles.forEach(role => {
        if (role.endsWith("_Contractor")) {
          const company = role.slice(0, -"_Contractor".length);
          if (company) companies.add(company.toLowerCase());
        } else if (role.endsWith("_Scanning Operator")) {
          const company = role.slice(0, -"_Scanning Operator".length);
          if (company) companies.add(company.toLowerCase());
        }
      });
      setAllowedCompanies([...companies]);
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await apiClient.get(`get_fdn_data`, {
          params: { projectId },
        });
        const normalizedData = response.data.fdnData.map(item => ({
          ...item,
          fdnData: item.fdnData?.fdnData || item.fdnData
        }));
        setApiData(normalizedData || []);
        setModules(response.data.modules || 0);
      } catch (error) {
        console.error('Error fetching FDN data:', error.response?.data || error.message);
        setApiData([]);
        setModules(0);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [projectId]);

  const searchFDNAddress = async (moduleNumber) => {
    try {
      const response = await apiClient.get(`search_fdn_address`, {
        params: { projectId, moduleNumber },
      });
      const fdnAddresses = response.data.map(item => item.fdnAddress);
      setSearchedFDNAddress(fdnAddresses.length > 0 ? fdnAddresses : null);
    } catch (error) {
      console.error('Error searching FDN address:', error.response?.data || error.message);
      setSearchedFDNAddress(null);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (searchField === 'moduleSerialNo' && value) {
      searchFDNAddress(value);
    } else {
      setSearchedFDNAddress(null);
    }
  };

  const getScannerCount = (item, modules) => {
    const cols = parseInt(item?.matchedDesignInput?.defineMatrixCols) || 0;
    const rows = parseInt(item?.matchedDesignInput?.defineMatrixRows) || 0;
    return cols * rows * modules;
  };

  const toggleModal = (fdnAddress) => {
    setModalOpen(!modalOpen);
    setSelectedFDN(fdnAddress);
    if (!modalOpen && fdnAddress && !scannedData[fdnAddress]) {
      const selectedItem = apiData.find(item => item.fdnAddress === fdnAddress);
      const scannerCount = selectedItem ? getScannerCount(selectedItem, modules) : 0;
      setScannedData((prev) => ({
        ...prev,
        [fdnAddress]: Array(scannerCount).fill(null),
      }));
    }
  };

  const StatusBar = ({ percentage, statusName }) => (
    <div className="relative w-full h-4 bg-gray-300 rounded">
      <div 
        className={`absolute inset-0 rounded bg-opacity-50`}
        style={{ width: `${percentage}%` }}
      >
        {statusName === 'completed' && <span className="bg-green-500 w-full h-full block rounded"></span>}
        {statusName === 'in-progress' && <span className="bg-yellow-500 h-full block rounded"></span>}
        {statusName === 'not-started' && <span className="bg-red-500 h-full block rounded"></span>}
      </div>
      <div className="absolute inset-0 flex items-center justify-center text-sm text-gray-600 font-semibold">
        {percentage}%
      </div>
    </div>
  );

  const calculateStatus = (item) => {
    const percentage = Math.min(item.statusPercentage || 0, 100);
    if (percentage === 100) return { percentage: 100, statusName: 'completed' };
    if (percentage > 0) return { percentage: Math.round(percentage), statusName: 'in-progress' };
    return { percentage: 0, statusName: 'not-started' };
  };

  const filteredData = apiData.filter((item) => {
    if (!searchTerm) return true;

    if (searchField === 'moduleSerialNo') {
      return searchedFDNAddress && searchedFDNAddress.includes(item.fdnAddress);
    }

    const value = (() => {
      switch (searchField) {
        case 'fdnAddress':
          return item.fdnAddress || '';
        case 'contractorName':
          return item?.fdnData?.fdnData?.assigned_to?.[0]?.Contractor || '';
        case 'installationDate':
          return item?.fdnData?.fdnData?.assigned_to?.[0]?.installationDate || '';
        case 'scanningOperator':
          return item?.fdnData?.fdnData?.assigned_to?.[0]?.['Scanning Operator'] || '';
        default:
          return '';
      }
    })();

    return value.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const downloadExcel = async () => {
    try {
      const response = await apiClient.post(`download_fdn_excel`, 
        { projectId },
        {
          headers: { 'Content-Type': 'application/json' },
          responseType: 'blob',
        }
      );
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'FDNData.xlsx');
    } catch (error) {
      console.error('Error downloading FDN Excel:', error.response?.data || error.message);
      alert('Failed to download Excel file. Please try again.');
    }
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploadError(null);
    setIsLoading(true);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('projectId', projectId);

    try {
      const response = await apiClient.post(`assign_modules_to_fdn_through_excel`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      alert('Modules assigned successfully!');
      const fetchResponse = await apiClient.get(`get_fdn_data`, {
        params: { projectId },
      });
      const normalizedData = fetchResponse.data.fdnData.map(item => ({
        ...item,
        fdnData: item.fdnData?.fdnData || item.fdnData
      }));
      setApiData(normalizedData || []);
      setModules(fetchResponse.data.modules || 0);
    } catch (error) {
      console.error('Error uploading Excel file:', error.response?.data || error.message);
      setUploadError('Failed to upload Excel file. Please check the file and try again.');
    } finally {
      setIsLoading(false);
      event.target.value = null;
    }
  };

  // ← UPDATED: Admin sees everything (including unassigned); others filtered by allowed companies
  const sortedFilteredData = [...filteredData]
    .filter((item) => {
      if (isAdmin) return true; // ← ADDED

      const contractorName = item?.fdnData?.assigned_to?.[0]?.Contractor || '';
      const scanningOperator = item?.fdnData?.assigned_to?.[0]?.['Scanning Operator'] || '';

      return allowedCompanies.some(company =>
        contractorName.toLowerCase() === company ||
        scanningOperator.toLowerCase() === company
      );
    })
    .sort((a, b) => a.fdnAddress.localeCompare(b.fdnAddress));

  return (
    <div className="mx-auto p-6 bg-gray-50 rounded-lg w-full shadow-lg">
      <h1 className="text-center text-4xl font-bold mb-8 text-gray-700">SITE SUPERVISOR INPUTS</h1>

      <div className="flex items-center justify-center my-[2em]">
        <form onSubmit={(e) => e.preventDefault()} className="flex relative w-[900px] max-w-full bg-gradient-to-r to-[#424752] rounded-lg shadow-lg transition-shadow duration-300 hover:shadow-2xl">
          <select 
            value={searchField}
            onChange={(e) => {
              setSearchField(e.target.value);
              setSearchTerm('');
              setSearchedFDNAddress(null);
            }}
            className="bg-white text-gray-700 px-3 h-12 outline-none border-r-2 border-gray-300 rounded-l-lg transition-colors duration-300"
          >
            <option value="fdnAddress">FDN Address</option>
            <option value="contractorName">Contractor Name</option>
            <option value="installationDate">Installation Date</option>
            <option value="scanningOperator">Scanning Operator</option>
            <option value="moduleSerialNo">Module Serial No</option>
          </select>
          <input
            type="text"
            value={searchTerm}
            onChange={handleSearchChange}
            placeholder={`Search by ${searchField.replace(/([A-Z])/g, ' $1').trim()}...`}
            className="w-full h-12 pl-4 pr-10 text-gray-700 placeholder-gray-500 rounded-r-lg bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-colors duration-300"
          />
          <button type="submit" className="absolute inset-y-0 right-0 flex items-center pr-4 text-gray-300 hover:text-gray-900">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-4.35-4.35m1.35-6.15a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </button>
        </form>
      </div>

      <div className="w-full bg-gray-100 shadow-inner rounded-lg p-4 flex items-center justify-center mb-4 pb-0">
        <ReactSpeedometer
          value={
            filteredData.length > 0
              ? Number(
                  (
                    filteredData.reduce((acc, curr) => {
                      const status = calculateStatus(curr);
                      return acc + status.percentage;
                    }, 0) / filteredData.length
                  ).toFixed(2)
                )
              : 0
          }
          minValue={0}
          maxValue={100}
          segments={5}
          needleColor="steelblue"
          startColor="red"
          endColor="green"
          textColor="black"
          height={180}
        />
      </div>      

      <div className="flex justify-between items-center mb-2 mt-0">
        {canUploadOffline ? (
          <div className="relative">
            <input
              type="file"
              accept=".xlsx,.xls"
              onChange={handleFileUpload}
              className="absolute opacity-0 w-0 h-0"
              id="file-upload"
              disabled={isLoading}
            />
            <label
              htmlFor="file-upload"
              className={`bg-[#424752] text-white px-4 py-3 rounded hover:bg-gray-600 cursor-pointer transition ${
                isLoading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {isLoading ? 'Uploading...' : 'Upload Offline File'}
            </label>
            {uploadError && <p className="text-red-500 text-sm mt-1">{uploadError}</p>}
          </div>
        ) : (
          <p className="text-red-600 font-medium text-lg">
            You don't have permission to upload files
          </p>
        )}

        <button 
          className={`bg-[#424752] text-white px-4 py-2 rounded hover:bg-gray-600 transition ${
            isLoading ? 'opacity-50 cursor-not-allowed' : ''
          }`}
          onClick={downloadExcel}
          disabled={isLoading}
        >
          File Download For Offline
        </button>
      </div>

      <table className="table-auto w-full bg-white border-collapse overflow-hidden shadow-md rounded-md">
        <thead>
          <tr className="bg-[#424752] text-white text-[13px] rounded-md">
            <th className="px-4 py-2">Sr.no</th>
            <th className="px-4 py-2">FDN Address</th>
            <th className="px-4 py-2">Table Layout</th>
            <th className="px-4 py-2">Status</th>
            <th className="px-4 py-2">Contractor Name</th>
            <th className="px-4 py-2">Installation Date</th>
            <th className="px-4 py-2">Scanning Operator</th>
          </tr>
        </thead>
        <tbody>
          {sortedFilteredData.map((item, index) => {
            const status = calculateStatus(item);
            const contractorName = item?.fdnData?.assigned_to?.[0]?.Contractor || 'N/A';
            const installationDate = item?.fdnData?.assigned_to?.[0]?.installationDate || 'N/A';
            const scanningOperator = item?.fdnData?.assigned_to?.[0]?.['Scanning Operator'] || 'N/A';

            return (
              <tr key={index} className="text-center hover:bg-gray-100">
                <td className="px-4 py-2">{index + 1}</td>
                <td className="px-4 py-2">{item.fdnAddress || 'N/A'}</td>
                <td className="px-4 py-2">
                  <button className="text-[#424752] hover:underline font-bold text-xl" onClick={() => toggleModal(item.fdnAddress)}>+</button>
                </td>
                <td className="px-4 py-2">
                  <StatusBar percentage={status.percentage} statusName={status.statusName} />
                </td>
                <td className="px-4 py-2">{contractorName}</td>
                <td className="px-4 py-2">{installationDate}</td>
                <td className="px-4 py-2">{scanningOperator}</td>
              </tr>
            );
          })}
          {sortedFilteredData.length === 0 && (
            <tr>
              <td colSpan="7" className="text-center py-4 text-gray-500">
                No matching results found
              </td>
            </tr>
          )}
        </tbody>
      </table>      

      {modalOpen && (
        <ScanningModal
          selectedFDN={selectedFDN}
          modalOpen={modalOpen}
          toggleModal={toggleModal}
          scannerCount={apiData.find(item => item.fdnAddress === selectedFDN) 
            ? getScannerCount(apiData.find(item => item.fdnAddress === selectedFDN), modules) 
            : 0}
          scannedData={scannedData}
          setScannedData={setScannedData}
        />
      )}
    </div>
  );
};

export default SiteSupervisorInput;